export default __webpack_public_path__ + "static/media/3.98a82e5f.jpg";